import { render, staticRenderFns } from "./PageProductRecall.vue?vue&type=template&id=a503bce6&scoped=true"
import script from "./PageProductRecall.vue?vue&type=script&lang=js"
export * from "./PageProductRecall.vue?vue&type=script&lang=js"
import style0 from "./PageProductRecall.vue?vue&type=style&index=0&id=a503bce6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a503bce6",
  null
  
)

export default component.exports